import Cookies from "js-cookie";
// Cookies.defaults = {
//   path: '/',
//   secure: true
// };
if (Cookies.get) {
  let map = {
    user_name: "a"
  };
  let old_get = Cookies.get;
  let old_set = Cookies.set;
  let old_remove = Cookies.remove;
  Cookies.get = function (key) {
    if (map[key]) {
      return old_get.call(this, key) || old_get.call(this, map[key]) || "";
    }
    return old_get.call(this, key);
  };
  Cookies.set = function (key, value, attributes) {
    if (map[key]) {
      old_set.call(this, map[key], value, attributes);
      return;
    }
    return old_set.call(this, key, value, attributes);
  };
  Cookies.remove = function (key, attributes) {
    if (map[key]) {
      old_remove.call(this, map[key], attributes);
      return;
    }
    return old_remove.call(this, key, attributes);
  };
}
export default Cookies;
